import { useState, type FormEvent } from 'react'
import { formatQty, parseQtyTenths, type InventoryPartDTO } from '@wf/shared'
import { useAddStock, useWithdrawStock } from './useInventory'

/**
 * „Teil entnehmen" (withdraw) bzw. „Teil zuführen" (add): Teil aus dem Inventar wählen + Stückzahl.
 * Menge wird immer positiv übergeben — die Richtung ergibt sich aus dem Modus.
 */
export function StockMovePanel({
  mode,
  parts,
  onClose,
}: {
  mode: 'withdraw' | 'add'
  parts: InventoryPartDTO[]
  onClose: () => void
}) {
  const [partId, setPartId] = useState<number | ''>('')
  const [qty, setQty] = useState('1')
  const [error, setError] = useState<string | null>(null)
  const withdraw = useWithdrawStock()
  const add = useAddStock()
  const mut = mode === 'withdraw' ? withdraw : add
  const title = mode === 'withdraw' ? 'Teil entnehmen' : 'Teil zuführen'

  function submit(event: FormEvent) {
    event.preventDefault()
    setError(null)
    if (partId === '') return setError('Bitte ein Teil wählen')
    const quantityTenths = parseQtyTenths(qty)
    if (quantityTenths <= 0) return setError('Menge muss größer als 0 sein')
    mut.mutate(
      { id: partId, body: { quantityTenths } },
      { onSuccess: onClose, onError: (e) => setError(e instanceof Error ? e.message : 'Buchung fehlgeschlagen') },
    )
  }

  return (
    <form className="wf-settings" onSubmit={submit}>
      <h3 className="wf-sectionhead">{title}</h3>
      {error ? (
        <div className="error" role="alert">
          {error}
        </div>
      ) : null}
      <div className="two">
        <label className="wf-field">
          <span className="wf-label">Teil (SNR / Bezeichnung)</span>
          <select className="wf-input" value={partId} onChange={(e) => setPartId(e.target.value === '' ? '' : Number(e.target.value))}>
            <option value="">– wählen –</option>
            {parts.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name} · {p.partNumber} (Bestand {formatQty(p.stockTenths)} {p.unit})
              </option>
            ))}
          </select>
        </label>
        <label className="wf-field">
          <span className="wf-label">Stückzahl</span>
          <input className="wf-input wf-tnum" inputMode="decimal" value={qty} onChange={(e) => setQty(e.target.value)} />
        </label>
      </div>
      <div className="wf-listfoot">
        <button type="submit" className="wf-btn" disabled={mut.isPending}>
          {title}
        </button>
        <button type="button" className="wf-btn wf-btn--ghost" onClick={onClose}>
          Abbrechen
        </button>
      </div>
    </form>
  )
}
